module.exports = __webpack_public_path__ + "minus-button.svg?5334cb6cfc735d9c9353d74ed0f3d800";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minus-button.svg
// module id = 175
// module chunks = 0